import ErrorAlert from './Error';
import CompletedAlert from './Completed';
import CompletedWithErrorAlert from './CompletedWithError';
import CanceledAlert from './Canceled';

import {
  STATUS_COMPLETED,
  STATUS_COMPLETED_WITH_ERRORS,
  STATUS_CANCELED,
  STATUS_FAILED,
} from 'scenes/TapjoyBidUpdate/constants';

export default ({ statusDetails }) => {
  switch (statusDetails?.status?.id) {
    case STATUS_COMPLETED:
      return <CompletedAlert statusDetails={statusDetails} />;
    case STATUS_CANCELED:
      return <CanceledAlert statusDetails={statusDetails} />;
    case STATUS_COMPLETED_WITH_ERRORS:
      return <CompletedWithErrorAlert statusDetails={statusDetails} />;
    case STATUS_FAILED:
      return <ErrorAlert statusDetails={statusDetails} />;
  }
  return null;
};
